<template lang="pug">
button.order-data-novelty-badge(
  v-if="totalCount > 0"
  type="button"
  :title="badgeTitle"
  aria-label="Ver novedades pendientes"
  @click="goToNovelties"
)
  span.order-data-novelty-badge__label.capitalize Novedades
  span.order-data-novelty-badge__count {{ totalCount }}
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'OrderDataNoveltyBadge',

  computed: {
    ...mapState('orderNovelty', ['dataCount', 'productCount']),

    totalCount () {
      return (this.dataCount || 0) + (this.productCount || 0)
    },

    badgeTitle () {
      const total = this.totalCount
      const parts = []

      if (this.dataCount > 0) {
        parts.push(`${this.dataCount} ${this.dataCount === 1 ? 'de datos' : 'de datos'}`)
      }

      if (this.productCount > 0) {
        parts.push(`${this.productCount} ${this.productCount === 1 ? 'de producto' : 'de producto'}`)
      }

      const detail = parts.length ? ` (${parts.join(', ')})` : ''
      return `${total} ${total === 1 ? 'novedad pendiente' : 'novedades pendientes'} en el último mes${detail}`
    }
  },

  mounted () {
    this.fetchDataNoveltyCount()
    this.fetchProductChangeCount()
  },

  methods: {
    ...mapActions('orderNovelty', ['fetchDataNoveltyCount', 'fetchProductChangeCount']),

    goToNovelties () {
      if (this.$route.name !== 'OrderDataNovelties') {
        this.$router.push({ name: 'OrderDataNovelties' })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.order-data-novelty-badge
  position fixed
  top .75rem
  right 1rem
  z-index 30
  display inline-flex
  align-items center
  gap .35rem
  min-height 2.25rem
  padding 0 .65rem
  margin 0
  border none
  border-radius 999px
  color #fff
  font-size .85rem
  font-weight 700
  line-height 1
  cursor pointer
  user-select none
  box-shadow 0 2px 12px rgba(0, 0, 0, .2)
  -webkit-tap-highlight-color transparent
  touch-action manipulation
  background var(--color-red, #c0392b)

  &:active
    opacity .85

.order-data-novelty-badge__label
  font-weight 600
  opacity .95

.order-data-novelty-badge__count
  display block
  font-size 1rem

@media (max-width: 768px)
  .order-data-novelty-badge
    top 3.35rem
    right .75rem
</style>



// WEBPACK FOOTER //
// src/components/elements/order/OrderDataNoveltyBadge.vue